<template>
  <div>
    <div class="navbar-fixed" ref="siteNav">
      <nav class="white" :class="$attrs['data-classes']">
        <div class="nav-wrapper">
          <div class="user-meta left">
            <div class="title-container" v-if="showUser && isLogin">
              <div
                class="welcome-text active grey-text text-darken-3"
                data-name=" Welcome Back"
              >
                <span v-html="fullNameX"></span>
              </div>
              <!--   <div class="text grey-text text-darken-3">{{ }}</div> -->
            </div>
            <div class="title-container" v-else>
              <div class="welcome-text grey-text text-darken-3">
                {{ title }}
              </div>
            </div>
          </div>

          <ul class="right">
            <!--   <li class="app-menu">
            <drop-down ref="dd" class="drop-down-content" :cover-trigger="true">
              <template #text
                ><i class="material-icons grey-text text-darken-2"
                  >menu</i
                ></template
              >
              <template #items>
                <div class="contents" style="padding:16px;">
                  <div class="title-text grey-text text-darken-3 center">
                    Application Options
                  </div>
                  <div class="nav-items">
                    <router-link
                      :to="{ name: opt.route }"
                      class=" grey-text text-darken-3 waves-effect"
                      v-show="
                        opt.route === 'Login' ? (isLogin ? false : true) : true
                      "
                      v-for="(opt, index) in nonAuthOpts"
                      :key="index"
                    >
                      <i
                        class="material-icons-outlined  grey-text text-darken-3"
                        >{{ opt.icon }}</i
                      >
                      {{ opt.text }}
                    </router-link>
                    <a
                      @click="$_logout()"
                      v-if="isLogin"
                      class=" grey-text text-darken-3 waves-effect"
                      style="cusor:pointer"
                    >
                      <i
                        class="material-icons-outlined  grey-text text-darken-3"
                        >exit_to_app</i
                      >
                      Signout
                    </a>
                  </div>
                </div>
              </template>
            </drop-down>
          </li> -->
            <li> 
              <router-link :to="{ name: 'Welcome', query: { start: 2 } }"
                class="grey-text text-darken-2 about-link hide-on-small-only">
                <i class="material-icons-outlined grey-text text-darken-2 left">live_help</i> About The Competition
              </router-link>
            </li>
            <li v-if="isLogin">
              <router-link tag="a" :to="{ query: { state: 'search' } }"
                ><i class="material-icons-outlined grey-text text-darken-2"
                  >auto_stories</i
                ></router-link
              >
            </li>
            <li>
              <a @click="$_openDrawer()"
                ><i class="material-icons grey-text text-darken-2">menu</i></a
              >
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <keep-alive>
      <side-nav ref="sidenav" />
    </keep-alive>
  </div>
</template>
<script>
import sideNav from "@/components/sideNav.component.vue";
import { logout } from "@/api/user.api";
/* import DropDown from '@/components/DropDown' */
export default {
  name: "TheTopBar",
  components: { sideNav /* AboutModal */ },
  props: {
    title: {
      type: String,
      default: "Act to Adapt",
    },
    showUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAppOptions: false,
      showAbout: false,
      nonAuthOpts: [
        {
          icon: "login",
          route: "Login",
          text: "Login",
        },
        {
          icon: "help_outline",
          route: "About",
          text: "About",
        },
        {
          icon: "home",
          route: "Home",
          text: "Home",
        },
      ],
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.User.isLogin;
    },
    fullNameX() {
      return this.$store.state.User.user.name;
    },
  },
  methods: {
    $_openDrawer() {
      this.$refs.sidenav.$_open();
    },
    $_logout() {
      this.$store.commit("User/LOAD_DEFAULT");
      this.$store.commit("Surveys/LOAD_DEFAULT");
      logout().then((x) => {
        this.$router.push({ path: "/login" });
      });
    },

    $_goTo(route) {
      if (this.$route.name === route) return;

      if (route === "About") {
        this.showAppOptions = false;
        this.showAbout = true;
      } else {
        this.$router.push({ name: route });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
 .about-link {
    line-height: 56px !important;
    @media screen and (min-width: 601px) {
      line-height: 64px !important;
    }
  }
.navbar-fixed {
  .welcome-text {
    font-size: 19.5px;
    font-family: "Libre Franklin", sans-serif;
    font-weight: 500;
    padding-left: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &[data-name] {
      margin-top: 8px;
    }
    &::before {
      content: attr(data-name);
      font-size: 12px;
      position: absolute;
      top: -10px;
    }
    /*  } */
  }
}
a {
  line-height: 1;
  i {
    &.material-icons-outlined {
      line-height: 56px !important;
      @media screen and (min-width: 601px) {
        line-height: 64px !important;
      }
    }
  }
}
.user-meta {
  width: 60%;
  @media screen and (max-width: 590px) {
    width: calc(100% - 108px);
  }
}
</style>
<style lang="scss">
.app-menu {
  .title-text {
    font-size: 16px;
    line-height: 24px;
    font-family: "Libre Franklin", sans-serif;
  }
}
</style>
